export default __webpack_public_path__ + "static/media/gunicorn.4a139c06.svg";